export class ResetPasswordResponce{
    uniqueToken!: string
    newPassword!: string
}